"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import "./bold.css.js";
import "./regular.css.js";
const AutoriaFont = () => jsx(Fragment, {});
export {
  AutoriaFont
};
